import { createApp } from 'vue'
import IssueDiagnosisWidget from '../components/issue_diagnosis/IssueDiagnosisWidget.vue'

document.querySelectorAll<HTMLElement>('#issue-diagnosis-widget').forEach((el) => {
  createApp(IssueDiagnosisWidget, {
    curriculumTopics: JSON.parse(el.dataset.curriculumTopics || '[]'),
    contactUrl: el.dataset.contactUrl || '',
    inflowRoute: el.dataset.inflowRoute || '',
  }).mount(el)
})
